module.exports = __webpack_public_path__ + "static/img/8.6cabb9a.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/3/4/eng/8.png
// module id = ZKG7
// module chunks = 0